import styles from "./Select.module.scss";
import Button from "./Button";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

const Select = ({ scrollTo }) => {
	const dtdRef = useRef(null);
	const semicolonRef = useRef(null);
	const codexRef = useRef(null);
	const nftRef = useRef(null);
	const respawnRef = useRef(null);
	const minigamesRef = useRef(null);
	const mazerunnerRef = useRef(null);
	const transylvaniaRef = useRef(null);
	const quizRef = useRef(null);
	const infinityRef = useRef(null);
	const treasureRef = useRef(null);

	let params = useParams();

	useEffect(() => {
		const refs = {
			dtd: dtdRef,
			semicolon: semicolonRef,
			codex: codexRef,
			nft: nftRef,
			respawn: respawnRef,
			minigames: minigamesRef,
			mazerunner: mazerunnerRef,
			transylvania: transylvaniaRef,
			quiz: quizRef,
			infinity: infinityRef,
			treasure: treasureRef,
		};

		params.eventname && scrollTo(refs[params.eventname].current);
	}, [params.eventname, scrollTo]);

	let navigate = useNavigate();
	const [event, setEvent] = useState(params.eventname);
	const handleEventChange = (e) => {
		navigate(`../${e.target.value}`);
		setEvent(e.target.value);
	};

	return (
		<div className={styles.select}>
			<ul>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="dtd"
						onChange={handleEventChange}
						checked={event === "dtd"}
					/>
					<Button reverseSkew>Destroy The Decibel</Button>
				</li>
				<p
					className={`${styles.body} ${event === "dtd" ? styles.show : ""}`}
					ref={dtdRef}
				>
					<em>
						The Battle of Exhausts <br />
					</em>
					Prize Money : <b>₹60K</b> <br />
					<b>29th</b> April
					<br />
					<b>10AM</b> Onwards
					<br />
					Registration Fee : <b>₹700</b> <br />
					Technical Partners : <b>Ozone Detailing and Car Spa</b> <br />
					<br />
					<Button
						href="https://tinyurl.com/destroythedecibel2022"
						target="_blank"
						className={styles.register}
						reverseSkew
						inverse
					>
						Register here
					</Button>
					<br />
					<b>Contacts :</b> <br />
					Sayanth Krishna :
					<a href="tel:+919400915508" className={styles.link}>
						+91 9400 91 5508
					</a>
					<br />
					Siyad :
					<a href="tel:+917736783667" className={styles.link}>
						+91 7736 78 3667
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="semicolon"
						onChange={handleEventChange}
						checked={event === "semicolon"}
					/>
					<Button reverseSkew>Semicolon</Button>
				</li>
				<p
					className={`${styles.body} ${
						event === "semicolon" ? styles.show : ""
					}`}
					ref={semicolonRef}
				>
					<em>
						Department Pavillion <br />
					</em>
					Technical Visual Expo showcasing themes under computer science.
					<br />
					<b>29th and 30th</b> April
					<br />
					<b>10:30AM</b> Onwards
					<br />
					<br />
					<b>Contacts :</b> <br />
					Varsha Shaju :
					<a href="tel:+918943698182" className={styles.link}>
						+91 8943 69 8182
					</a>
					<br />
					Joshna Joshy :
					<a href="tel:+918086596881" className={styles.link}>
						+91 8086 59 6881
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="codex"
						onChange={handleEventChange}
						checked={event === "codex"}
					/>
					<Button reverseSkew>CodeX</Button>
				</li>
				<p
					className={`${styles.body} ${event === "codex" ? styles.show : ""}`}
					ref={codexRef}
				>
					<em>
						Control the Code, Control the World <br />
					</em>
					<br />
					Pop your knuckles and buckle yourself up!! If you are a software
					enthusiast and think you got a few tricks up your sleeves, you are at
					the right spot. Coding problem can be attended in any of the following
					languages (C, C++, Java, Python, Javascript) <br />
					<br /> Prize Money : <br />
					<b>₹3K - Winner</b>
					<br />
					<b>₹2K - Runner Up</b>
					<br />
					<b>₹1K - Second Runner Up</b>
					<br />
					<br />
					<b>30th</b> April
					<br />
					<b>10:30AM - 1:30PM</b>
					<br />
					Registration Fee : <b>₹50</b> <br />
					<br />
					<Button
						href="https://forms.gle/HqsREb4NRg2s13Qz8"
						target="_blank"
						className={styles.register}
						reverseSkew
						inverse
					>
						Register here
					</Button>
					<br />
					<b>Contacts :</b> <br />
					Aadithye N :
					<a href="tel:+918592047613" className={styles.link}>
						+91 8592 04 7613
					</a>
					<br />
					Anurag Chandra :
					<a href="tel:+917012597830" className={styles.link}>
						+91 7012 59 7830
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="nft"
						onChange={handleEventChange}
						checked={event === "nft"}
					/>
					<Button reverseSkew>NFT Workshop</Button>
				</li>
				<p
					className={`${styles.body} ${event === "nft" ? styles.show : ""}`}
					ref={nftRef}
				>
					<em>
						Digital artwork showcase and NFT workshop. Introducing NFTs and
						future opportunities <br />
					</em>
					In collaboration with{" "}
					<a href="www.instagram.com/nftmalayali" className={styles.link}>
						@nftmalyali
					</a>
					<br />
					Featuring <br />{" "}
					<a href="www.instagram.com/nadameldesigns" className={styles.link}>
						@Nadamel Designs
					</a>{" "}
					<br />{" "}
					<a href="https://www.melvinthambi.com/" className={styles.link}>
						@Melvin Thambi
					</a>
					<br />{" "}
					<a href="www.instagram.com/franciskurien" className={styles.link}>
						@Francis Kurien
					</a>
					<br />
					<br />
					<b>30th</b> April
					<br />
					<b>2PM Onwards</b>
					<br />
					Registration Fee : <b>₹50</b> <br />
					<br />
					<Button
						href="https://docs.google.com/forms/d/e/1FAIpQLSdow8wwupsuvxisRp5GeREyKJ5k3-7KiG6CIOO8CptsF8RSDg/viewform"
						target="_blank"
						className={styles.register}
						reverseSkew
						inverse
					>
						Register here
					</Button>
					<br />
					<b>Contacts :</b> <br />
					Surya Narayan K V :
					<a href="tel:+918086836630" className={styles.link}>
						+91 8086 83 6630
					</a>
					<br />
					Athul Raj :
					<a href="tel:+918593839407" className={styles.link}>
						+91 8593 83 9407
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="respawn"
						onChange={handleEventChange}
						checked={event === "respawn"}
					/>
					<Button reverseSkew>Respawn Gaming</Button>
				</li>
				<p
					className={`${styles.body} ${event === "respawn" ? styles.show : ""}`}
					ref={respawnRef}
				>
					<em>
						Gamers don’t die, they respawn. <br />
					</em>
					<br /> Prize Money : <b>₹15K</b>
					<br />
					<b>30th</b> April
					<br />
					<b>10:30AM - 1:30PM</b>
					<br />
					<br />
					Registration Fee : <br />
					Valorant : <b>₹100</b> per head. <br />
					PES : <b>₹50</b> per head. <br />
					<br />
					<Button
						href="https://docs.google.com/forms/d/e/1FAIpQLSfUUzR6oPakH3R1G-fKu3v24IagstY_MAXfSF8a5exP8mIHOg/viewform"
						target="_blank"
						className={styles.register}
						reverseSkew
						inverse
					>
						Register here
					</Button>
					<br />
					<b>Contacts :</b> <br />C Vinay Sankar :
					<a href="tel:+918301816821" className={styles.link}>
						+91 8301 81 6821
					</a>
					<br />
					Akshay Sreekumar :
					<a href="tel:+918113982423" className={styles.link}>
						+91 8113 98 2423
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="minigames"
						onChange={handleEventChange}
						checked={event === "minigames"}
					/>
					<Button reverseSkew>Minigames</Button>
				</li>
				<p
					className={`${styles.body} ${
						event === "minigames" ? styles.show : ""
					}`}
					ref={minigamesRef}
				>
					<em>
						Tiny amount of fun is still fun. <br />
					</em>
					<br />
					Pause, Breathe and Relax, indulge yourself in some cute little games.
					Flip Tac Toe, Carpet Ride , Ballon Cup, Face the Cookie etc <br />
					<br /> Prize Money : <b>₹1K</b>
					<br />
					<b>29th and 30th</b> April
					<br />
					<b>11:30AM Onwards</b>
					<br />
					<br />
					Registration Fee : <b>₹20</b> per head.
					<br />
					<br />
					<b>Contacts :</b> <br />
					Arya AJ :
					<a href="tel:+919495423093" className={styles.link}>
						+91 9495 42 3093
					</a>
					<br />
					Arun Das CH :
					<a href="tel:+918606931917" className={styles.link}>
						+91 8606 93 1917
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="mazerunner"
						onChange={handleEventChange}
						checked={event === "mazerunner"}
					/>
					<Button reverseSkew>The Maze Runner</Button>
				</li>
				<p
					className={`${styles.body} ${
						event === "mazerunner" ? styles.show : ""
					}`}
					ref={mazerunnerRef}
				>
					<em>
						Think you can solve complex problems?👀 Well, this one might be just
						handcrafted for you!
					</em>
					<br />
					<br />
					With themes varying from Dense Forests to Thunderous Lightning, you
					will be hit with many slender obstacles.
					<br />
					Think you got the Squad to challenge the game itself? 👀 Come join us
					and win handsome rewards. (The fastest team wins) <br />
					<br /> Prize Money : <b>Worth ₹3K</b> <br />
					<br />
					<b>29th and 30th</b> April
					<br />
					<b>10:30AM Onwards</b>
					<br />
					Registration Fee : <b>₹30</b> <br />
					Prize : <b>Food Coupon</b> sponsored by <b>Burger Hub</b>.
					<br />
					<br />
					<b>Contacts :</b> <br />
					Vaisakh :
					<a href="tel:+918129337461" className={styles.link}>
						+91 8129 33 7461
					</a>
					<br />
					Somkumar :
					<a href="tel:+918139801524" className={styles.link}>
						+91 8139 80 1524
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="transylvania"
						onChange={handleEventChange}
						checked={event === "transylvania"}
					/>
					<Button reverseSkew>Transylvania</Button>
				</li>
				<p
					className={`${styles.body} ${
						event === "transylvania" ? styles.show : ""
					}`}
					ref={transylvaniaRef}
				>
					<em>
						A game of Hide and Shriek. <br />
					</em>
					<br />
					Knock Knock. Who's there? 👀 Boo.👻 Look around cause the Skeletons
					might just raise a cheer of Bone Apetite!!
					<br />
					<br />
					<b>29th and 30th</b> April
					<br />
					<b>11:30AM Onwards</b>
					<br />
					Registration Fee : <b>₹30</b> <br />
					<br />
					<b>Contacts :</b> <br />
					Dona Vincent :
					<a href="tel:+917306067127" className={styles.link}>
						+91 7306 06 7127
					</a>
					<br />
					Guruprasad :
					<a href="tel:+917025048112" className={styles.link}>
						+91 7025 04 8112
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="quiz"
						onChange={handleEventChange}
						checked={event === "quiz"}
					/>
					<Button reverseSkew>El Cuestionario</Button>
				</li>
				<p
					className={`${styles.body} ${event === "quiz" ? styles.show : ""}`}
					ref={quizRef}
				>
					<em>
						Test your pop cult and technical knowledge. <br />
					</em>
					Quiz will be conducted in 3 different topics. BTS Army, Computer
					Science, Avengers
					<br /> Prize Money : <b>₹6K (₹2K for each)</b>
					<br />
					<b>29th</b> April
					<br />
					<b>10AM -1PM</b>
					<br />
					Registration Fee : <b>₹30</b> <br />
					<br />
					<b>Contacts :</b> <br />
					Vaishnavi Kishore :
					<a href="tel:+919497417495" className={styles.link}>
						+91 9497 41 7495
					</a>
					<br />
					Gayathri Satheeshkumar :
					<a href="tel:+919188068794" className={styles.link}>
						+91 9188 06 8794
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="infinity"
						onChange={handleEventChange}
						checked={event === "infinity"}
					/>
					<Button reverseSkew>Infinity Fun</Button>
				</li>
				<p
					className={`${styles.body} ${
						event === "infinity" ? styles.show : ""
					}`}
					ref={infinityRef}
				>
					<em>
						Play to win but enjoy the game. <br />
					</em>
					<br /> Prize Money : <b>Worth ₹3K</b> <br />
					<b>29th and 30th</b> April
					<br />
					<b>10AM Onwards</b>
					<br />
					Registration Fee : <b>₹10</b> per game. <br />
					<br />
					<b>Contacts :</b> <br />
					Chethana Nandan :
					<a href="tel:+918086277945" className={styles.link}>
						+91 8086 27 7945
					</a>
					<br />
					Nithya Prakash :
					<a href="tel:+918433887468" className={styles.link}>
						+91 8433 88 7468
					</a>
				</p>
				<li>
					<input
						type="radio"
						name="event"
						id=""
						value="treasure"
						onChange={handleEventChange}
						checked={event === "treasure"}
					/>
					<Button reverseSkew>Treasure Hunt</Button>
				</li>
				<p
					className={`${styles.body} ${
						event === "treasure" ? styles.show : ""
					}`}
					ref={treasureRef}
				>
					<em>
						This might be your chance to bring out your inner Sherlock Holmes
						<br />
					</em>
					Online and Offline Treasure Hunt
					<br /> Prize Money : <br />
					<b>₹2K - Online</b>
					<br />
					<b>₹2K - Offline (₹1K per day)</b>
					<br />
					<br />
					<b>29th and 30th</b> April (Offline)
					<br />
					<b>10:30AM Onwards</b>
					<br />
					<b>26th - 30th</b> April (Online)
					<br />
					Registration Fee : <b>₹20</b> per person (Offline) <br />
					<br />
					<b>Contacts :</b> <br />
					Abhijit Sheheer :
					<a href="tel:+917560811791" className={styles.link}>
						+91 7560 81 1791
					</a>
					<br />
					Abilash KB :
					<a href="tel:+919526950017" className={styles.link}>
						+91 9526 95 0017
					</a>
				</p>
			</ul>
		</div>
	);
};

export default Select;
